"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.IllustrationServiceMessage = void 0;
var _withIllustration = _interopRequireDefault(require("../withIllustration"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IllustrationServiceMessage = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
    viewBox: "0 0 277 235",
    ...props,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      "clip-path": "url(#clip0_863_194)",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M277 0H0V234.961H277V0Z",
        fill: "#F3F7FE"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M73.2051 66.6232H210.492C212.43 66.6232 214 68.299 214 70.3662V154.798C214 156.865 212.43 158.541 210.492 158.541H122.348L93.0974 175.253L91.1473 158.541H73.2051C71.2675 158.541 69.6968 156.865 69.6968 154.798V70.3662C69.6968 68.299 71.2675 66.6232 73.2051 66.6232Z",
        fill: "#C3D4F7"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M65.5083 59H202.795C204.733 59 206.304 60.6758 206.304 62.743V147.175C206.304 149.242 204.733 150.918 202.795 150.918H114.651L85.4006 167.63L83.4505 150.918H65.5083C63.5707 150.918 62 149.242 62 147.175V62.743C62 60.6758 63.5707 59 65.5083 59Z",
        fill: "white"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M117.294 99.1948C117.294 89.6262 125.124 81.8694 134.783 81.8694C144.442 81.8694 152.273 89.6262 152.273 99.1948V109.449L158.834 120.852L110.733 120.852L117.294 109.449V99.1948ZM130.411 129.514H139.155V125.183H130.411V129.514Z",
        fill: "#7EA3EF"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("defs", {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("clipPath", {
        id: "clip0_863_194",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
          width: "277",
          height: "235",
          fill: "white"
        })
      })
    })]
  });
};
exports.IllustrationServiceMessage = IllustrationServiceMessage;
var _default = exports.default = (0, _withIllustration.default)('IllustrationServiceMessage')(IllustrationServiceMessage);